import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import {
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomRequiredInputLabel,
  CustomTextFeildforFamily,
  StyledDateContainer,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import { useState } from "react";
import { Box, FormControl, InputAdornment } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import styles from "../../contactUs/contactus.module.scss";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import CustomSelectField from "../../common/CustomSelectField/CustomSelectField";
import { PersonSearch } from "@mui/icons-material";
import ReportsSearchDevotee from "../ReportsSearchDevotee/ReportsSearchDevotee";

const RevenueReport = ({ sendDataToParent, getReportData }: any) => {
  const [formData, setFormData] = useState({
    date: dayjs().format("MM-DD-YYYY"),
    signInName: "",
    typeOfService: "poojaBooking",
  });
  const [loading, setLoading] = useState(false);

  const servicesType = [
    { key: "Pooja Booking", value: "poojaBooking" },
    { key: "Donation", value: "donation" },
    { key: "Hall Rental", value: "hallRental" },
    { key: "Prasadam", value: "prasadam" },
    { key: "Calendar", value: "calendar" },
    { key: "Others", value: "others" },
  ];

  const handleFieldChange = (field: any, value: any) => {
    if (field === "date") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");

      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  // Search Devotee setters and handlers
  const [openSearchDevotee, setOpenSearchDevotee] = useState(false);

  const handleOpenSearchDevoteeDialog = () => {
    setOpenSearchDevotee(true);
  }

  const handleClose = () => {
    setOpenSearchDevotee(false);
  }

  const hanldeSelectUser = (username: string) => {
    handleFieldChange(
      "signInName",
      username?.toUpperCase()
    );
    handleClose();
  } 

  const ServicesTypesDropdown = (): React.ReactElement => {
    return (
        <FormControl style={{ width: "30%" }}>
          <CustomSelectField
            id="typeOfService"
            handleDropdownChange={handleFieldChange}
            errorMessage={""}
            dropDownList={servicesType}
            value={formData.typeOfService}
            fieldName="typeOfService"
            optionLabel="key"
            optionValue="value"
            placeholder={""}
            overrideStyles={{backgroundColor: "white"}}
          />
        </FormControl>
    );
  };

  const handleRevenueReport = async () => {
    let reqBody = {
      ...(formData.date && { donationDate: formData.date }),
      ...(formData.signInName && { searchUserName: formData.signInName.toUpperCase() }),
      ...(formData.typeOfService && { serviceType: formData.typeOfService }),
      pagination: true,
      pageNumber: 1,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/revenue/REVENUE_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then(async (res) => {
        setLoading(false);
        const response = res.data.data.map((report: any) => {
          return {
            "Sr.No": report.sno,
            "Receipt Number": report.receiptnumber,
            "Reference Number": report.referencenumber,
            "Name (Sign-in)":report.fullname,
            "Mode of Payment": report.donationtype,
            "Check Number": report.checknumber,
            "Donation/Puja (ID)":report.poojaname,
            "Date of Payment":report.dateofdonation,
            "Amount":formatAmount(report.amount),
            ...(report.onwhosename && { "Description": report.onwhosename }),
            ...(report.phoneresidence && { "Home Phone": report.phoneresidence }),
            ...(report.email && { "Email": report.email }),
          };
        });
        getReportData(response);
        sendDataToParent(true, { reqBody,
          totalDonatedAmount:res.data.totalDonatedAmount,
          totalElements:res.data.totalElements,
          pageSize:res.data.pagesize });
      })

      .catch((err) => {});
  };

  const handleSave = async (): Promise<any> => {
    try {
      handleRevenueReport();
    } catch (error) {
      setLoading(false);
    }
  };

  const datePicker = (): React.ReactElement => {
    return (
      <div style={{ width: "30%" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={formData.date ? dayjs(formData.date, "MM/DD/YYYY") : ""}
                onChange={(value) => {
                  handleFieldChange("date", value);
                }}
                className={styles.textField}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: "16px" }}
      className={styles.abhishekamReportsMainContainer}
    >
      <Box>
        {CustomRequiredInputLabel("Search By Donation Date", false)}
        {datePicker()}
      </Box>

      <Box sx={{width: "30%"}}>
        {CustomRequiredInputLabel("Sign-in Name", false)}
        <CustomTextFeildforFamily
          required
          fullWidth
          value={formData.signInName}
          onChange={(e) => {
            handleFieldChange("signInName", e.target.value);
          }}
          onBlur={() => {
            const inputUserName = formData.signInName.toUpperCase();
            handleFieldChange('signInName', inputUserName);
          }}
          className={styles.textFieldTimeBg}
          sx={{
            "& .MuiOutlinedInput-root": {
              pr: "7px"
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <PersonSearch sx={{ml: "10px", cursor: "pointer", color: "#F05802"}} onClick={handleOpenSearchDevoteeDialog}/>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box >
        {CustomRequiredInputLabel("Type of service booked", false)}
        {ServicesTypesDropdown()}
      </Box>
      <CommonOutlinedButton
        sx={{ width: "fit-content", height: "38px" }}
        onClick={handleSave}
        disabled={loading}
        id="submit"
      >
        <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
      </CommonOutlinedButton>
      {openSearchDevotee && <ReportsSearchDevotee open={openSearchDevotee} handleClose={handleClose} hanldeSelectUser={hanldeSelectUser}/>}
    </Box>
  );
};
export default RevenueReport;
